import React, { useState } from "react";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea"; // Make sure this exists and is correctly implemented

const AmenitiesPopup = ({ data, data1 }) => {
  return (
    <div class="mx-auto  md:w-[500px] w-full">
      <div class="relative w-full h-full max-w-xl md:h-auto">
        <div class="relative bg-white rounded-lg shadow ">
          <div class="px-6 py-6 lg:px-8">
            <InputText
              inputType="text"
              title="Amenities"
              name="amenities"
              classStar="text-red-500"
              content={data?.Amenities || ""}
              disabled={true}
            />

            <div className="col-span-2">
              <TextArea
                title="Description"
                rows={7}
                placeholder="Enter Description"
                content={data?.Description}
                classStar={"text-red-500"}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmenitiesPopup;
